import * as React from "react";
import { Fun, IOWidget, mk_widget, option, Options, Unit, Widget } from "../widget";

export interface DivOptions<o> extends Options {
  onMouseEnter?: Fun<HTMLElement, o | null>
  onMouseLeave?: Fun<HTMLElement, o | null>
}

/** @deprecated Use [[wrapHTML]] instead. */
export const div_io = function <i, o>(element: "meta" | "span" | "div" | "nav" | "footer", options?: DivOptions<o>) {
  return (inner: IOWidget<i, o> | IOWidget<i, o>[]): IOWidget<i, o> => (input: i) => mk_widget({
    run: (on_done: (output: o) => void) => {
      let ws = Array<IOWidget<i, o>>().concat(inner)
      return React.createElement(element,
        {
          id: option("id", options),
          role: option("role", options),
          className: options ? options.className : undefined,
          style: option("style", options),
          key: options ? options.key : undefined,
          onMouseEnter: e => {
            if (options && options.onMouseEnter) {
              let res = options.onMouseEnter(e.currentTarget)
              if (res) {
                e.stopPropagation()
                on_done(res)
                return false
              }
            }
          },
          onMouseLeave: e => {
            if (options && options.onMouseLeave) {
              let res = options.onMouseLeave(e.currentTarget)
              if (res) {
                e.stopPropagation()
                on_done(res)
                return false
              }
            }
          },
          ...option("extraProperties", options)
        },
        element == "meta" || ws.length == 0 ? null :
          ws.length == 1 ? ws[0](input).run(output => on_done(output))
            : ws.map(w => w(input).run(output => on_done(output)))
      )
    }
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const div = function <o>(options?: DivOptions<o>) {
  return (inner?: Widget<o> | Widget<o>[]): Widget<o> =>
    div_io<Unit, o>("div", options)(!inner ? [] : Array<Widget<o>>().concat(inner).map(w => (_: {}) => w))({})
}

/** @deprecated Use [[wrapHTML]] instead. */
export const nav = function <o>(options?: Options) {
  return (inner?: Widget<o> | Widget<o>[]): Widget<o> =>
    div_io<Unit, o>("nav", options)(!inner ? [] : Array<Widget<o>>().concat(inner).map(w => (_: {}) => w))({})
}

/** @deprecated Use [[wrapHTML]] instead. */
export const span = function <o>(options?: Options) {
  return (inner?: Widget<o> | Widget<o>[]): Widget<o> =>
    div_io<Unit, o>("span", options)(!inner ? [] : Array<Widget<o>>().concat(inner).map(w => (_: {}) => w))({})
}

/** @deprecated Use [[wrapHTML]] instead. */
export const meta = function <o>(options?: Options): Widget<o> {
  return div_io<Unit, o>("meta", options)([])({})
}

/** @deprecated Use [[wrapHTML]] instead. */
export const hr = function <o>(options?: Options): Widget<o> {
  return mk_widget({
    run: _ => <hr />
  })
}
